import type { Color, File, Piece, Rank, Role, Square } from './types';

const FILES: File[] = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
const RANKS: Rank[] = ['1', '2', '3', '4', '5', '6', '7', '8'];

const FEN_ROLE: Record<string, Role> = {
  p: 'p',
  n: 'n',
  b: 'b',
  r: 'r',
  q: 'q',
  k: 'k',
};

function toSquare(fileIndex: number, rankIndex: number): Square | undefined {
  const file = FILES[fileIndex];
  const rank = RANKS[rankIndex];
  if (!file || !rank) return undefined;
  return `${file}${rank}`;
}

/** Pieces from the board field of a FEN (no chess.js). */
export function piecesFromFen(fen: string): Array<Piece & { square: Square }> {
  const board = fen.trim().split(/\s+/)[0] ?? '';
  const rows = board.split('/');
  const out: Array<Piece & { square: Square }> = [];

  for (let row = 0; row < 8; row++) {
    const rankIndex = 7 - row;
    let fileIndex = 0;
    for (const ch of rows[row] ?? '') {
      if (fileIndex >= 8) break;
      if (ch >= '1' && ch <= '8') {
        fileIndex += Number(ch);
        continue;
      }
      const role = FEN_ROLE[ch.toLowerCase()];
      const square = toSquare(fileIndex, rankIndex);
      if (role && square) {
        const color: Color = ch === ch.toUpperCase() ? 'w' : 'b';
        out.push({ color, role, square });
      }
      fileIndex += 1;
    }
  }

  return out;
}

/** Chessboard shade — a1 is dark. */
export function squareShade(square: Square): 'light' | 'dark' {
  const fileIndex = FILES.indexOf(square[0] as File);
  const rankIndex = Number(square[1]) - 1;
  if (fileIndex < 0 || rankIndex < 0 || rankIndex > 7) return 'dark';
  return (fileIndex + rankIndex) % 2 === 0 ? 'dark' : 'light';
}
